

<template>
    <div class="message">  
        <div v-for="(item,index) in msgHistoryObjects" class="d-flex MessageRow" @click="IntoChat(item)" 
                v-bind:id="'Row' + (item.MsgType == 1 ? item.msgHistory.UserId : item.msgHistory.RoomId)">
            <div class="MessageRowImg" id="MessageRowImg" v-bind:style="item.MsgType == 2 ? GroupStyle: SingleStyle">
                <span class="circle"></span>
                {{SetImgSpan(item)}}
            </div>

            <div class="pl-3 flex-grow-1">
                <div class="d-flex"> 
                    <span class="MessageRowId">{{item.MsgType == 1 ? item.msgHistory.UserId : item.msgHistory.RoomId}}</span>
                    <span class="MessageRowName">{{item.MsgType == 1 ? item.msgHistory.UserName :item.msgHistory.RoomName}}</span>
                    <span class="MessageRowDate ml-auto" >{{formatTime(item.msgHistory.LastMsgDate)}}</span>
                </div>
                <div>
                    <p class="MessageRowMes">{{SubStringMsg(item)}}</p>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import {app} from '@/main'
import Vue from 'vue'
import moment from 'moment'

export default {
    name: 'Message',
    props: ['msgHistoryObjects'],
    components:{},
    data () {
        return {
            SingleStyle:{
                background: '#a0d1e2'
            },
            GroupStyle:{
                background: '#8CEA90'
            }
        }
    },
    methods:{
        SetImgSpan(item){
            if(item.MsgType == 2){ //群組
                return 'G';
            }else if(item.MsgType == 1){
                //系統 810 811 812
                if(item.msgHistory.UserId == 810 ||item.msgHistory.UserId == 811 ||item.msgHistory.UserId == 812){
                    return '系';
                }else{//非系統回傳第一個字
                    if(item.msgHistory.UserName != undefined){
                        return item.msgHistory.UserName.substring(0,1);
                    }else{
                        return '';
                    }
                }
            }
        },
        IntoChat(item){
            this.$router.push({
                name: 'Chat',
                params: { 
                    msgObjects:item,
                }
            });
        },
        SubStringMsg(item){
            if(item.msgHistory.LastMsgContent != undefined){
                if(item.msgHistory.LastMsgContent.length >40){
                    item.msgHistory.LastMsgContent = item.msgHistory.LastMsgContent.substring(0, 40) + '...';
                }
                return item.msgHistory.LastMsgContent;
            }else{
                return '';
            }
        },
        formatTime(date){
            return moment(date).format('YYYY-MM-DD');
        },
        //接收到WS最新消息
        getNewestMessages(NewItem){
            if(NewItem.Sender != sessionStorage.getItem('UserId') && 
                ( NewItem.MessageType == 1 || NewItem.MessageType == 2)){
                var NewMsg = '';
                if(NewItem.MessageType == 1 && NewItem.SendType != 3){ //msg
                    NewMsg = NewItem.Content.Message;
                }else if(NewItem.MessageType == 2&& NewItem.SendType != 3){ //file
                    NewMsg = NewItem.Content.FileUrl;
                }else if(NewItem.MessageType == 1 && NewItem.SendType == 3){ //Announcement
                    var msgData = JSON.parse(NewItem.Content.Message)
                    NewMsg = msgData.Message;
                    // console.log('NewMsg',NewMsg);
                }

                // console.log(NewItem);
                var findMsgObject = {};
                

                //檢查是不是原有聊天室
                for(var i = 0; i < this.msgHistoryObjects.length; i++){
                    if(NewItem.SendType == 1){//Student = 1,
                        if(NewItem.Sender == this.msgHistoryObjects[i].msgHistory.UserId){
                            findMsgObject = this.msgHistoryObjects[i];
                            break;
                        }
                    }else if(NewItem.SendType == 2){ // Group = 2, 
                        if(NewItem.Receiver == this.msgHistoryObjects[i].msgHistory.RoomId){//接收者是自己群組但不是自己傳送的訊息
                            findMsgObject = this.msgHistoryObjects[i];
                            break;
                        }
                    }else if(NewItem.SendType == 3){// Announcement = 3
                        // var msgData = JSON.parse(NewItem.Content.Message)
                        if(msgData.GroupId == this.msgHistoryObjects[i].msgHistory.RoomId){
                            findMsgObject = this.msgHistoryObjects[i];
                            break;
                        }
                    }
                }
                
                //原有聊天室則移到最上面
                if(findMsgObject.msgHistory != undefined){
                    this.msgHistoryObjects.splice(this.msgHistoryObjects.indexOf(findMsgObject),1);
                    findMsgObject.msgHistory.LastMsgContent = NewMsg;
                    findMsgObject.msgHistory.LastMsgDate = NewItem.SendDateTime;
                    this.msgHistoryObjects.unshift(findMsgObject);
                }
                //如果不是原本有聊天的 新增聊天室    
                else{  
                    if(NewItem.SendType == 1){ //single room
                        findMsgObject = {
                            MsgType:NewItem.SendType,
                            msgHistory:{
                                LastMsgContent: NewMsg,
                                LastMsgDate: NewItem.SendDateTime,
                                UserId: NewItem.Sender,
                                UserName: NewItem.RoomName,
                            }
                        }
                    }else if(NewItem.SendType == 2){ // group room
                        findMsgObject = {
                            MsgType:NewItem.SendType,
                            msgHistory:{
                                LastMsgContent: NewMsg,
                                LastMsgDate: NewItem.SendDateTime,
                                RoomId: NewItem.Receiver,
                                UserName: NewItem.RoomName,
                            }
                        }
                    }else if(NewItem.SendType == 3){ // Announcement
                        findMsgObject = {
                            MsgType:2,
                            msgHistory:{
                                LastMsgContent: NewMsg,
                                LastMsgDate: NewItem.SendDateTime,
                                RoomId: msgData.GroupId,
                                UserName: msgData.GroupId,
                            }
                        }
                    }
                    this.msgHistoryObjects.unshift(findMsgObject);
                    // console.log('findMsgObject',findMsgObject);
                }

                //新增為未讀class
                var rowId = this.getRowId(findMsgObject);
                // console.log(rowId)
                document.querySelector(rowId).classList.add('unread');
            }
        },
        getRowId(item){
            //新增為未讀class
            if(item.MsgType == 1){
                return '#Row' + item.msgHistory.UserId;
                // rowId = 
            }else if(item.MsgType == 2){
                return '#Row' + item.msgHistory.RoomId;
                // rowId = '#' + item.msgHistory.RoomId
            } 
        },
        //有未讀訊息 
        UnReadMsg(){
            var rowId = '';
            this.msgHistoryObjects.forEach((item,index) => {
                if(item.msgHistory.UnreadCount > 0){
                    rowId = this.getRowId(item);
                    document.querySelector(rowId).classList.add('unread');

                    // this.msgHistoryObjects.splice(this.msgHistoryObjects.indexOf(item),1);
                    // this.msgHistoryObjects.unshift(item);
                }
            });
        },
    },
    created(){
        this.$root.$refs.message = this;
    },
    updated(){
        this.UnReadMsg();
    },
    mounted(){
        this.UnReadMsg();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Message.vue